import { useEffect, useRef } from "react";
import { useStore } from "../context/StoreContext";

const EVENTS = ["pointerdown", "pointermove", "keydown", "wheel", "touchstart", "scroll"];
const HIDDEN_LIMIT = 60 * 1000;

// Locks after N idle minutes, and optionally when the app was hidden for over a minute
export default function AutoLock() {
  const { state, status, hasPasscode, lockNow } = useStore();
  const minutes = Number(state?.settings.autoLockMinutes ?? 5);
  const onHide = !!state?.settings.lockOnHide;
  const last = useRef(Date.now());
  const hiddenAt = useRef(null);
  const active = status === "ready" && hasPasscode();

  useEffect(() => {
    if (!active) return;
    last.current = Date.now();
    const bump = () => (last.current = Date.now());
    EVENTS.forEach((e) => window.addEventListener(e, bump, { passive: true, capture: true }));
    const vis = () => {
      if (document.visibilityState === "hidden") return (hiddenAt.current = Date.now());
      const away = hiddenAt.current ? Date.now() - hiddenAt.current : 0;
      hiddenAt.current = null;
      if (onHide && away > HIDDEN_LIMIT) lockNow();
      else if (minutes > 0 && Date.now() - last.current > minutes * 60000) lockNow();
    };
    document.addEventListener("visibilitychange", vis);
    const t = setInterval(() => {
      if (minutes > 0 && Date.now() - last.current > minutes * 60000) lockNow();
    }, 5000);
    return () => {
      EVENTS.forEach((e) => window.removeEventListener(e, bump, { capture: true }));
      document.removeEventListener("visibilitychange", vis);
      clearInterval(t);
    };
  }, [active, minutes, onHide]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
